import React from 'react';
import { useAsyncState, useIsBuyer } from '@/utils/hooks';
import { getCommentThreadRelationInfo } from '@/services/comments';
import { CommentThreadType } from '@/types';
import { BygrModule, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { CustomRedirect } from '@/components/navigation';
import NotFound from '@/components/error-pages/NotFound';
import { getModuleUrl } from '@/utils/returnUrl';
import { urlCombine } from '@/utils/url';
function goToModule(targetModule: BygrModule, relativeUrl: string) {
    window.location.href = urlCombine(getModuleUrl(targetModule, window.APP_CONFIG), relativeUrl);
}

const ExternalRoutingChat: React.FC<{ threadId: number }> = ({ threadId }) => {
    const isBuyer = useIsBuyer();
    const [relation] = useAsyncState(() => getCommentThreadRelationInfo(threadId), [threadId], null);

    if (!relation) {
        return <LoadingIndicator />;
    }

    if (isBuyer) {
        switch (relation.threadType) {
            case CommentThreadType.ChangeRequest:
                return <CustomRedirect to={`/change-requests/${relation.entityId}`} />;
            case CommentThreadType.ResidentialUnit:
                return <CustomRedirect to={`/chat`} />;
            case CommentThreadType.Case:
                goToModule(BygrModule.Aftermarket, `cases/${relation.entityId}`);
                return <LoadingIndicator />;
            case CommentThreadType.ResidentialUnitAftermarket:
                goToModule(BygrModule.Aftermarket, `messages`);
                return <LoadingIndicator />;
        }
    } else {
        switch (relation.threadType) {
            case CommentThreadType.ChangeRequest:
                return (
                    <CustomRedirect
                        to={`/projects/${relation.projectId}/residential-units/${relation.residentialUnitId}/changes/${relation.entityId}`}
                    />
                );
            case CommentThreadType.ExternalAgreement:
                return (
                    <CustomRedirect
                        to={`/projects/${relation.projectId}/external-agreements/messages/${relation.entityId}`}
                    />
                );
            case CommentThreadType.ResidentialUnit:
                return (
                    <CustomRedirect
                        to={`/projects/${relation.projectId}/residential-units/${relation.residentialUnitId}/comments/${threadId}`}
                    />
                );
            case CommentThreadType.Project:
                return <CustomRedirect to={`/projects/${relation.projectId}/messages/${threadId}`} />;
            case CommentThreadType.Case:
                goToModule(BygrModule.Aftermarket, `${relation.projectId}/units/${relation.residentialUnitId}/cases`);
                return <LoadingIndicator />;
            case CommentThreadType.ResidentialUnitAftermarket:
                goToModule(BygrModule.Aftermarket, `${relation.projectId}/units/${relation.residentialUnitId}/messages`);
                return <LoadingIndicator />;
        }
    }

    return <NotFound />;
};

export default ExternalRoutingChat;
